<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <!-- Register v1 -->
    <div class="card mb-0">
      <div class="card-body" style="text-align-last: center;">
        <a href="javascript:void(0);" class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
          <h2 class="brand-text text-primary ml-1">{{ coreConfig.app.appName }}</h2>
        </a>
        <div class="card-body" *ngIf="loading" style="align-self: center;">
          <div class="spinner-border mr-50" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <div class="card-body" *ngIf="!loading" style="align-self: center;">
            <a href="javascript:void(0);" class="brand-logo">
              <img src="{{ inviteInfo.locationInfo.locationLogo }}" alt="brand-logo" height="28" />
            </a>
            <h2 class="brand-text text-primary ml-1">{{ inviteInfo.locationInfo.locationName }}</h2>
            
            <!-- / Select Location -->
            <form action="#" #newInviteForm="ngForm">
              <div class="row">

                

                <!-- First Name -->
                <div class="form-group col-6">
                  <label class="form-label" for="basic-icon-default-firstname">First Name</label>
                  <input
                    type="text"
                    class="form-control dt-first-name"
                    id="basic-icon-default-firstname"
                    placeholder="John"
                    name="user-firstname"
                    [(ngModel)]="inviteContent['firstName']"
                    [value]=""
                    [class.error]="newInviteForm.submitted && FFirstNameRef.invalid"
                    #FFirstNameRef="ngModel"
                    required
                    aria-label="John"
                    aria-describedby="basic-icon-default-firstname2"
                  />
                  <span *ngIf="newInviteForm.submitted && FFirstNameRef.invalid" class="invalid-form">
                    <small class="form-text text-danger" *ngIf="FFirstNameRef.errors.required">This field is required!</small>
                  </span>
                </div>
                <!-- / First Name -->

                <!-- Last Name -->
                <div class="form-group col-6">
                  <label class="form-label" for="basic-icon-default-lastname">Last Name</label>
                  <input
                    type="text"
                    id="basic-icon-default-lastname"
                    class="form-control dt-lastname"
                    placeholder="Doe"
                    aria-label="Doe"
                    aria-describedby="basic-icon-default-lastname2"
                    name="user-lastname"
                    [(ngModel)]="inviteContent['lastName']"
                    [class.error]="newInviteForm.submitted && FLastNameRef.invalid"
                    #FLastNameRef="ngModel"
                    required
                  />
                  <span *ngIf="newInviteForm.submitted && FLastNameRef.invalid" class="invalid-form">
                    <small class="form-text text-danger" *ngIf="FLastNameRef.errors.required">This field is required!</small>
                  </span>
                </div>
                <!-- / Last Name -->
                
                <!-- Email -->
                <div class="form-group col-12">
                  <label class="form-label" for="basic-icon-default-email">Email</label>
                  <input
                    type="text"
                    id="basic-icon-default-email"
                    class="form-control dt-email"
                    placeholder="john.doe@example.com"
                    aria-label="john.doe@example.com"
                    aria-describedby="basic-icon-default-email2"
                    name="user-email"
                    [(ngModel)]="inviteContent['contact']"
                    [class.error]="newInviteForm.submitted && FEmailRef.invalid"
                    #FEmailRef="ngModel"
                    required
                  />
                  <span *ngIf="newInviteForm.submitted && FEmailRef.invalid" class="invalid-form">
                    <small class="form-text text-danger" *ngIf="FEmailRef.errors.required">This field is required!</small>
                  </span>
                  <small class="form-text text-muted"> You can use a valid email. </small>
                </div>
                <!-- / Email -->

                <!-- Phone -->
                <div class="form-group col-12">
                  <label class="form-label" for="basic-icon-default-email">Phone</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1">+61</span>
                    </div>
                    <input 
                    type="text" 
                    id="basic-icon-default-phone"
                    class="form-control" 
                    placeholder="0000 000 000" 
                    mask="9000 000 000" 
                    aria-describedby="basic-icon-default-phone2"
                    name="user-phone"
                    [(ngModel)]="inviteContent['phone']"
                    [class.error]="newInviteForm.submitted && FPhoneRef.invalid"
                    #FPhoneRef="ngModel"
                    required
                  />
                  </div>
                  <span *ngIf="newInviteForm.submitted && FPhoneRef.invalid" class="invalid-form">
                    <small class="form-text text-danger" *ngIf="FPhoneRef.errors.required">This field is required!</small>
                  </span>
                  <small class="form-text text-muted"> You can only use numbers </small>                    
                </div>    
                <!-- / Phone -->

              </div>
            </form>


        </div>
        <div class="modal-footer" *ngIf="!loading">
          <button type="button" class="btn btn-primary"  (click)="sendInvite()" rippleEffect>
            Next
          </button>
          <input style="display: none;"
            type="text" 
            id="openInviteToken"
          />
          <button type="button" id="openInviteBtn" class="btn btn-primary" style="display: none;" (click)="openInvite()" rippleEffect>
            Open Invite
          </button>
        </div>
      

      </div>
    </div>
    <!-- /Register v1 -->
  </div>
</div>
